import React, { useState } from "react";
import Modal from "react-modal";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    background: "transparent",
    padding: 0,
    maxWidth: "520px",
    width: "92vw",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1100,
  },
};

const SpecialInstructionsDisplay = ({ text, compact = true }) => {
  const [showModal, setShowModal] = useState(false);

  if (!text) return null;

  if (!compact) {
    return (
      <div className="event-detail-row">
        <span className="event-detail-label">Special Instructions:</span>
        <span className="event-detail-value">{text}</span>
      </div>
    );
  }

  return (
    <>
      <div className="event-detail-row special-instructions-row">
        <span className="event-detail-label">
          Special{" "}
          <br />
          Instructions:
        </span>
        <span className="event-detail-value">
          <button
            type="button"
            className="special-instructions-view-link"
            onClick={() => setShowModal(true)}
          >
            View
          </button>
        </span>
      </div>

      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        style={modalStyles}
        portalClassName="special-instructions-modal"
        contentLabel="Special Instructions"
        ariaHideApp={false}
      >
        <div className="special-instructions-modal-header">
          <h3>Special Instructions</h3>
          <button
            type="button"
            className="special-instructions-modal-close"
            onClick={() => setShowModal(false)}
            aria-label="Close"
          >
            <img
              src={window.getPublicUrl("/assets/images/close.svg")}
              alt=""
            />
          </button>
        </div>
        <div className="special-instructions-modal-body">{text}</div>
      </Modal>
    </>
  );
};

export default SpecialInstructionsDisplay;
